// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".privacyPolicy[data-v-d3e46762]{margin-bottom:8px}#privacy-policy-anchor[data-v-d3e46762]{scroll-margin-bottom:220px;scroll-margin-top:20px;transition:all .3s ease}#privacy-policy-anchor.highlight-scroll[data-v-d3e46762]{animation:highlight-pulse-d3e46762 2s ease-in-out;border-radius:4px}@keyframes highlight-pulse-d3e46762{0%{background-color:transparent}50%{background-color:rgba(103,100,255,.1)}to{background-color:transparent}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
